import { useQuery } from "@apollo/client/react";
import { useParams } from "react-router-dom";
import { OrganizationType } from "../api/graphql";
import { useCurrentCorrespondent } from "../SessionBoundary";
import CallSkeleton from "./CallSkeleton";
import { GetMeetingInfoDocument } from "./GetMeetingInfo.generated";
import RoomScreen from "./RoomScreen.tsx";
import { useCallPolling } from "./useCallPolling.ts";

export default function VideoCallScreen() {
  const { id } = useParams<{ id: string }>();

  const user = useCurrentCorrespondent();

  if (!id) throw new Error("Missing meeting id");

  const { data, loading, error, refetch } = useQuery(GetMeetingInfoDocument, {
    fetchPolicy: "no-cache", // do not cache access token
    variables: { meetingId: id },
  });
  if (error) throw error;

  const call = data?.meeting.call;

  const currentParticipant = call?.participants.find(
    (p) => p.externalId === user.id
  );

  const denied = !!call && !currentParticipant;

  // poll for meeting information. mostly useful for on-demand meetings but
  // also for incidents where CVH doesn't start on time.
  useCallPolling({ call, refetch });

  // loading or transitioning
  if (loading || !data || !call) return <CallSkeleton />;

  return (
    <RoomScreen
      allowRating
      allowTextFeedback={
        user.__typename === "Visitor" &&
        // Healthcare org members cannot leave feedback
        // because of HIPAA regulations
        !user.organizationMemberships?.some(
          (om) => om.organization.type === OrganizationType.Healthcare
        )
      }
      call={call}
      fromPath={`/call/${data.meeting.id}`}
      currentParticipant={currentParticipant}
      denied={denied}
    />
  );
}
